/* unplugin-vue-components disabled */import { render } from "./videoMonitoring.vue?vue&type=template&id=0db61a1a&scoped=true"
import script from "./videoMonitoring.vue?vue&type=script&lang=js"
export * from "./videoMonitoring.vue?vue&type=script&lang=js"

import "./videoMonitoring.vue?vue&type=style&index=0&id=0db61a1a&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db61a1a"]])

export default __exports__